var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ButtonComponent from "./ButtonComponent";
// FontAwesome icon mapping for backward compatibility
const getIconClass = (type) => {
    const iconMap = {
        "search": "fal search",
        "close": "fal times",
        "done": "fal check",
        "arrow-up": "fal arrow-up",
        "arrow-down": "fal arrow-down",
        "arrow-left": "fal arrow-left",
        "arrow-right": "fal arrow-right",
        "filter": "fal filter",
        "edit": "fal pencil",
        "delete": "fal trash",
        "pin": "fal thumbtack",
        "copy": "fal copy",
        "plus": "fal plus"
    };
    return iconMap[type];
};
/**
 * Icon button component with set of default icons and options to render any icon
 * @export
 *
 *
 * @example
 * ```
 *  <IconButton
 *      type="search"
 *      onClick={()=> {alert("Clicked")}}
 *      className="custom-css-class"
 *  />
 * ```
 *
 *
 * @example
 * ```
 *  <IconButton
 *      icon="fas search"
 *      ...
 *  />
 * ```
 *
 *
 */
const IconButton = (props) => {
    const { type, borderless, icon, buttonType } = props, rest = __rest(props, ["type", "borderless", "icon", "buttonType"]);
    // Handle borderless styling
    const borderlessStyles = borderless ? { border: 'none' } : {};
    // Get FontAwesome icon class for backward compatibility
    const iconClass = type ? getIconClass(type) : icon || undefined;
    return (_jsx(ButtonComponent, Object.assign({ leftIcon: iconClass, iconOnly: true, styles: borderlessStyles, type: buttonType || 'button' }, rest)));
};
export default IconButton;
